import { Link } from "react-router-dom";
import { customSitesContent } from "../content/custom-sites.js";

function IconPerformance() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M13 3 5 14h6l-1 7 8-11h-6l1-7Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}

function IconBrand() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.6" />
      <path d="M9 12h6M12 9v6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

function IconOwnership() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M6 6h12v12H6V6Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M9 10h6M9 14h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M8 6V4h8v2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

function IconHosting() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <ellipse cx="12" cy="6" rx="8" ry="3" stroke="currentColor" strokeWidth="1.6" />
      <path
        d="M4 6v4c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 10v4c0 1.7 3.6 3 8 3s8-1.3 8-3v-4"
        stroke="currentColor"
        strokeWidth="1.6"
      />
    </svg>
  );
}

const FEATURE_ICONS = {
  performance: IconPerformance,
  brand: IconBrand,
  ownership: IconOwnership,
  hosting: IconHosting,
};

export default function CustomSitesPage() {
  const c = customSitesContent;

  return (
    <article className="site-page customsites-page">
      <div className="site-page__inner site-page__inner--wide customsites-page__inner">
        <header className="customsites-hero">
          <p className="site-page__eyebrow">{c.eyebrow}</p>
          <h1 className="site-page__title customsites-hero__title">{c.title}</h1>
          <p className="site-page__lead customsites-hero__lead">{c.lead}</p>
          <ul className="customsites-hero__points">
            {c.heroPoints.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
          <p className="site-page__cta customsites-hero__cta">
            <Link to="/contact" className="site-button-primary">
              {c.cta.primary}
            </Link>
            <Link to="/pricing" className="site-button-ghost">
              {c.cta.secondary}
            </Link>
          </p>
        </header>

        <section className="customsites-features" aria-labelledby="customsites-features-heading">
          <h2 id="customsites-features-heading" className="customsites-section-title">
            Not WordPress. Not rented themes.
          </h2>
          <div className="customsites-features__grid">
            {c.features.map((f) => {
              const Icon = FEATURE_ICONS[f.icon] ?? IconPerformance;
              return (
                <article key={f.id} className="customsites-feature-card">
                  <span className="customsites-feature-card__icon" aria-hidden="true">
                    <Icon />
                  </span>
                  <h3>{f.title}</h3>
                  <p>{f.body}</p>
                </article>
              );
            })}
          </div>
        </section>

        <section className="customsites-stacks" aria-labelledby="customsites-stacks-heading">
          <h2 id="customsites-stacks-heading" className="customsites-section-title">
            {c.stacks.title}
          </h2>
          <div className="customsites-stacks__groups">
            <div>
              <p className="customsites-stacks__label">Frontends</p>
              <ul className="customsites-stacks__chips">
                {c.stacks.frontends.map((chip) => (
                  <li key={chip}>{chip}</li>
                ))}
              </ul>
            </div>
            <div>
              <p className="customsites-stacks__label">Backends</p>
              <ul className="customsites-stacks__chips">
                {c.stacks.backends.map((chip) => (
                  <li key={chip}>{chip}</li>
                ))}
              </ul>
            </div>
          </div>
          <ul className="customsites-hosting__chips" aria-label="Hosting options">
            <li>Self-host</li>
            <li>Google Cloud</li>
            <li>AWS</li>
            <li>Vercel</li>
          </ul>
        </section>

        <section className="customsites-engineering" aria-labelledby="customsites-engineering-heading">
          <h2 id="customsites-engineering-heading" className="customsites-section-title">
            {c.engineering.title}
          </h2>
          <p className="customsites-engineering__body">{c.engineering.body}</p>
          <ul className="customsites-engineering__points">
            {c.engineering.points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </section>

        <section className="customsites-integrations" aria-labelledby="customsites-integrations-heading">
          <h2 id="customsites-integrations-heading" className="customsites-section-title">
            {c.integrations.title}
          </h2>
          <p className="customsites-integrations__body">{c.integrations.body}</p>
          <ul className="customsites-integrations__chips">
            {c.integrations.chips.map((chip) => (
              <li key={chip}>{chip}</li>
            ))}
          </ul>
        </section>

        <section
          className="customsites-dashboard-preview"
          aria-labelledby="customsites-deploy-heading"
        >
          <h2 id="customsites-deploy-heading" className="customsites-section-title">
            {c.deployHub.title}
          </h2>
          <p className="customsites-dashboard-preview__subtitle">{c.deployHub.subtitle}</p>

          <div className="customsites-dash" role="img" aria-label="Sample deploy and release dashboard">
            <div className="customsites-dash__top">
              <div>
                <p className="customsites-dash__eyebrow">Deploy hub</p>
                <p className="customsites-dash__business">{c.deployHub.projectName}</p>
              </div>
              <span className="customsites-dash__live">
                <span className="customsites-dash__live-dot" />
                {c.deployHub.liveBadge}
              </span>
            </div>

            <div className="customsites-dash__metrics">
              <div className="customsites-dash__metric">
                <span className="customsites-dash__metric-value">
                  {c.deployHub.metrics.environments}
                </span>
                <span className="customsites-dash__metric-label">Environments</span>
              </div>
              <div className="customsites-dash__metric customsites-dash__metric--highlight">
                <span className="customsites-dash__metric-value">
                  {c.deployHub.metrics.lastDeploy}
                </span>
                <span className="customsites-dash__metric-label">Last production deploy</span>
              </div>
              <div className="customsites-dash__metric">
                <span className="customsites-dash__metric-value">
                  {c.deployHub.metrics.uptime}
                </span>
                <span className="customsites-dash__metric-label">30-day uptime</span>
              </div>
            </div>

            <div className="customsites-dash__panels">
              <div className="customsites-dash__panel">
                <h3>Environments</h3>
                <ul className="customsites-dash__active-list">
                  {c.deployHub.active.map((env) => (
                    <li key={env.id} className="customsites-dash__active-item">
                      <div className="customsites-dash__active-head">
                        <strong>{env.id}</strong>
                        <span className="customsites-dash__pill">{env.state}</span>
                      </div>
                      <p>{env.snippet}</p>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="customsites-dash__panel">
                <h3>Recent deploys</h3>
                <div className="customsites-dash__table-wrap">
                  <table className="customsites-dash__table">
                    <thead>
                      <tr>
                        <th scope="col">Deploy</th>
                        <th scope="col">Target</th>
                        <th scope="col">Result</th>
                        <th scope="col">Notes</th>
                        <th scope="col">When</th>
                      </tr>
                    </thead>
                    <tbody>
                      {c.deployHub.recent.map((row) => (
                        <tr key={row.id}>
                          <td>{row.id}</td>
                          <td>{row.topic}</td>
                          <td>
                            <span
                              className={`customsites-dash__outcome${row.outcome === "Rolled back" ? " customsites-dash__outcome--warn" : ""}`}
                            >
                              {row.outcome}
                            </span>
                          </td>
                          <td>{row.response}</td>
                          <td className="customsites-dash__time">{row.time}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>

        <p className="site-page__cta">
          <Link to="/contact" className="site-button-primary">
            {c.cta.primary}
          </Link>
          <Link to="/" className="site-button-ghost">
            ← Back to home
          </Link>
        </p>
      </div>
    </article>
  );
}
